
import { IAuthUser, IUserAuthPasswordReset, IUserFormValues } from "../models/Auth";
import agent from "./agent";
import { ApiFactory } from "./ApiFactory";
import { SetAppLoadComplete, setAuthState, SetDataLoadComplete } from "../store/slices/Auth/AuthSlice";
import { Action } from "@reduxjs/toolkit";

export default class AuthApi {

    private apiFactory: ApiFactory;
    constructor(apiFactory: ApiFactory) {
        this.apiFactory = apiFactory;
    }

    login = async (values: IUserFormValues) => {

        try {
            const user: IAuthUser = await agent.api.post('/account', values);

            this.apiFactory.store.dispatch(setAuthState(user));
            await this.cacheSystemLookups(user);
        }
        catch (error) {
            throw error;
        }
    }

    logout = async () => {
        try {
            await agent.api.post('/account/logout', {});

            this.apiFactory.store.dispatch({type: "reset"});

            //After reset we have to update the appLoadComplete flag to true otherwise the UI will display a blank page (AuthMiddleware.tsx)
            this.apiFactory.store.dispatch(SetAppLoadComplete(true));

        }
        catch (error) {
            throw error;
        }
    }

    refresh = async () => {
        try {

            let user: IAuthUser = await agent.api.post('/account/refreshtoken', {});

            if(user.token !== undefined) {
                this.apiFactory.store.dispatch(setAuthState(user));
                await this.cacheSystemLookups(user);
            }
            else {
                //refresh failed. Reset state to force login.
                this.apiFactory.store.dispatch({type: "reset"});

                //After reset we have to update the appLoadComplete flag to true otherwise the UI will display a blank page (AuthMiddleware.tsx)
                this.apiFactory.store.dispatch(SetAppLoadComplete(true));
            }

            return user;
        }

        catch (error) {
            this.apiFactory.store.dispatch(setAuthState(null));
            throw error;
        }
    }

    private cacheSystemLookups = async (user: IAuthUser) => {

        await this.apiFactory.dealerApi.getDealer({dealerId: user.user.dealerId});
        await this.apiFactory.dealerApi.getDealerList({includeInactive: true});
        await this.apiFactory.lookupApi.getBoatSeriesList();
        await this.apiFactory.lookupApi.getYearList();
        this.apiFactory.store.dispatch(SetDataLoadComplete(true));
    }

    forgotpassword = async (params: any) => {
        try {
            let result = await agent.api.post('/account/forgotpassword', params);
            return result;
        }
        catch (error) {
            throw error;
        }
    }

    resetpassword = async (params: any) => {
        try {
            let result: IAuthUser = await agent.api.post('/account/resetpassword', params);
            this.apiFactory.store.dispatch(setAuthState(result));
        }
        catch (error) {
            throw error;
        }
    } 

    resetauthpassword = async (params: IUserAuthPasswordReset) => {
        try {
            await agent.api.post('/user/resetpassword', params);
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

}
